import CryptoJS from 'crypto-js';

const KEY = CryptoJS.enc.Hex.parse(process.env.VUE_APP_AES_KEY);
const IV = CryptoJS.enc.Hex.parse(process.env.VUE_APP_AES_IV);

export function encrypt(text) {
  const encrypted = CryptoJS.AES.encrypt(text, KEY, {
    iv: IV,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  });
  const base64 = encrypted.toString(); // Base64 estándar
  const base64url = base64
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/, ''); // remove padding
  
  return base64url;
}